export default {
    DRAW_RECTANGLE: 'DRAW_RECTANGLE',
    DRAW_ELLIPSE: 'DRAW_ELLIPSE',
    DRAW_POLYGON: 'DRAW_POLYGON',
    DRAW_TEXT: 'DRAW_TEXT',
    DRAW_TOKEN: 'DRAW_TOKEN',
    DRAW_IMAGE: 'DRAW_IMAGE',
    DRAW_BRUSH: 'DRAW_BRUSH',
    SELECT: 'SELECT',
    REMOVE: 'REMOVE',
    CHANGE_LAYER: 'CHANGE_LAYER',
    BRING_TO_FRONT: 'BRING_TO_FRONT',
    SEND_TO_BACK: 'SEND_TO_BACK',
}